var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{attrs:{"fluid":""}},[_c('b-row',{staticClass:"info-header"},[_c('b-col',{staticClass:"icon",attrs:{"col":"","sm":"1"}},[_c('img',{attrs:{"src":"static/img/location-icon.png"}})]),_vm._v(" "),_c('b-col',{attrs:{"col":"","sm":"10"}},[_c('div',{staticClass:"info-title"},[_vm._v(_vm._s(_vm.location))])])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-44dd440f","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/location.vue
// module id = XHkg
// module chunks = 1